'use client';

import { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { api, ApiError } from '@/lib/api';

// Self-service password change for any logged-in user: confirm current, set new.
// The server revokes other sessions and keeps this one signed in.
export default function ChangePassword() {
  const [cur, setCur] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setMsg(null);
    if (next.length < 8) {
      setMsg({ ok: false, text: '新密碼至少 8 個字元' });
      return;
    }
    if (next !== confirm) {
      setMsg({ ok: false, text: '兩次輸入的新密碼不一致' });
      return;
    }
    setBusy(true);
    try {
      await api.changePassword(cur, next);
      setMsg({ ok: true, text: '✅ 密碼已更新,其他裝置已登出' });
      setCur('');
      setNext('');
      setConfirm('');
    } catch (err) {
      let text = '更新失敗,請稍後再試';
      if (err instanceof ApiError) {
        if (err.code === 'current_password_incorrect') text = '目前密碼不正確';
        else if (err.code === 'password_too_short') text = '新密碼至少 8 個字元';
      }
      setMsg({ ok: false, text });
    } finally {
      setBusy(false);
    }
  }

  const input =
    'w-full rounded-lg border border-zinc-300 bg-transparent px-3 py-2 text-sm dark:border-zinc-700';

  return (
    <form onSubmit={submit} className="space-y-2.5">
      <div className="flex items-center gap-1.5 text-sm font-medium text-zinc-500">
        <KeyRound size={14} /> 修改密碼
      </div>
      <input
        type="password"
        autoComplete="current-password"
        placeholder="目前密碼"
        value={cur}
        onChange={(e) => setCur(e.target.value)}
        className={input}
      />
      <input
        type="password"
        autoComplete="new-password"
        placeholder="新密碼(至少 8 碼)"
        value={next}
        onChange={(e) => setNext(e.target.value)}
        className={input}
      />
      <input
        type="password"
        autoComplete="new-password"
        placeholder="再次輸入新密碼"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        className={input}
      />
      {msg && (
        <p className={`text-xs ${msg.ok ? 'text-emerald-600 dark:text-emerald-400' : 'text-rose-500'}`}>
          {msg.text}
        </p>
      )}
      <button
        type="submit"
        disabled={busy || !cur || !next || !confirm}
        className="w-full rounded-xl bg-brand py-2.5 text-sm font-semibold text-white disabled:opacity-50"
      >
        {busy ? '更新中…' : '更新密碼'}
      </button>
    </form>
  );
}
